<template>
    <div class="container-fluid p-3">
        <div class="row">
            <div class="col-12">
                <upload-file-panel></upload-file-panel>
            </div>
        </div>
    </div>
</template>
<script>
import UploadFilePanel from '../components/user/upload-file-panel'

export default {
    components: {
        UploadFilePanel
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/upload-file-page.vue